module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "template_body"
  }, [_c('nav-bar', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.shouldShowNavigation),
      expression: "shouldShowNavigation"
    }]
  }), _vm._v(" "), _c('side-bar', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.shouldShowNavigation),
      expression: "shouldShowNavigation"
    }]
  }), _vm._v(" "), _c('div', {
    staticClass: "page-container"
  }, [(_vm.alert) ? _c('div', {
    staticClass: "notificationdiv"
  }, [_vm._v("\n      " + _vm._s(_vm.alrtshow) + "\n      "), _c('span', {
    staticClass: "notificationClose",
    on: {
      "click": _vm.campaignsEmailAlertUpdate
    }
  }, [_c('i', {
    staticClass: "fas fa-times"
  })])]) : _vm._e(), _vm._v(" "), (_vm.showSystemAlertBanner) ? _c('div', {
    staticClass: "system-alert-banners"
  }, [_c('div', {
    staticClass: "system-alert-banner"
  }, [_c('i', {
    staticClass: "fas fa-exclamation-triangle sa-banner-icon"
  }), _vm._v(" "), _c('div', {
    staticClass: "sa-banner-text"
  }, [_c('strong', [_vm._v("Needs attention")]), _vm._v(" "), _c('span', {
    staticClass: "sa-banner-sep"
  }, [_vm._v("—")]), _vm._v(" "), _vm._l((_vm.systemAlertTypes), function(type) {
    return _c('a', {
      key: type.key,
      staticClass: "sa-banner-tag",
      attrs: {
        "href": "#",
        "title": 'Open ' + type.label + ' settings'
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.goToSystemAlertType(type)
        }
      }
    }, [_vm._v("\n            " + _vm._s(type.label) + "\n            "), _c('span', {
      staticClass: "sa-banner-count"
    }, [_vm._v(_vm._s(type.count))])])
  }), _vm._v(" "), _c('a', {
    staticClass: "sa-banner-fix",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.goToSystemAlerts($event)
      }
    }
  }, [_vm._v("View all")])], 2), _vm._v(" "), _c('span', {
    staticClass: "sa-banner-close",
    attrs: {
      "title": "Hide until you sign in again"
    },
    on: {
      "click": function($event) {
        _vm.hideSystemAlertBanner()
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-times"
  })])])]) : _vm._e(), _vm._v(" "), _c('router-view', {
    key: _vm.$route.fullPath
  }), _vm._v(" "), _c('div', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "px-3 py-4 sm-text-center fs-13 hint-text"
  }, [_vm._v("\n        Copyright © " + _vm._s(_vm.moment(Date.now()).format("YYYY")) + " |\n        HumanFirewall"), _c('sup', {
    staticClass: "fs-14"
  }, [_vm._v("®")]), _vm._v(" | All Rights Reserved.\n        "), _vm._m(0)])])], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "pull-right sm-pull-reset"
  }, [_vm._v("\n          Version: "), _c('span', {
    staticClass: "hint-text"
  }, [_vm._v("3.05")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-9f361b70!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/main.vue
// module id = 1637
// module chunks = 32